import React, { useEffect, useState } from 'react';
import { Chip } from '@mui/material';
import WifiIcon from '@mui/icons-material/Wifi';
import WifiOffIcon from '@mui/icons-material/WifiOff';

/**
 * Small chip that shows online/offline status.
 * Listens to browser online/offline events for live updates.
 */
export default function OfflineBadge() {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <Chip
      icon={online ? <WifiIcon /> : <WifiOffIcon />}
      label={online ? 'Online' : 'Offline'}
      size="small"
      color={online ? 'success' : 'error'}
      variant={online ? 'outlined' : 'filled'}
      sx={{
        fontWeight: 600,
        '& .MuiChip-icon': { fontSize: 16 },
      }}
    />
  );
}
